import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BusResponse } from '../../participante/models/processo-manual.model';
import { ArquivoDocumentoManualDTO } from '../../documento/models/proposta-manual-documento.model';
import { DadosProposta } from '../models/dados-proposta.model';
import { PropostaFinanciamentoRepository } from '../repositories/proposta-financiamento.repository';

@Injectable({
  providedIn: 'root'
})
export class PropostaFinanciamentoService implements PropostaFinanciamentoRepository {
  private readonly apiParticipante = 'participante/';

  constructor(private readonly http: HttpClient) {}

  buscarDadosProposta(matricula: string): Observable<DadosProposta> {
    return this.http.get<DadosProposta>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiParticipante}dadosProposta/${matricula}`
    );
  }

  salvarRascunhoDadosPropostaManual(matricula: string, dados: DadosProposta): Observable<DadosProposta> {
    return this.http.put<DadosProposta>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiParticipante}propostaManual/dadosProposta/${matricula}/rascunho`,
      dados
    );
  }

  finalizarDadosPropostaManual(matricula: string, dados: DadosProposta): Observable<BusResponse<ArquivoDocumentoManualDTO>> {
    return this.http.put<BusResponse<ArquivoDocumentoManualDTO>>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiParticipante}propostaManual/dadosProposta/${matricula}/finalizar`,
      dados
    );
  }
}
